// Thanks page redirect.
document.addEventListener('wpcf7mailsent', function (e) {
  if (e.detail && e.detail.apiResponse && e.detail.apiResponse.redirect) {
    location.href = e.detail.apiResponse.redirect
  }
}, false)

// Loading class.
;[...document.querySelectorAll('.wpcf7')].forEach(form => {
  const btn = form.querySelector('[type=\"submit\"]')

  let disableSubmit = false;

  btn.addEventListener('click', e => {
      if (disableSubmit === true) {
          e.preventDefault();
      }
      disableSubmit = true;
  })

  form.addEventListener('wpcf7beforesubmit', e => {
    btn.classList.add('loading')
  })

  form.addEventListener('wpcf7submit', e => {
    btn.classList.remove('loading')
    disableSubmit = false;
  })

  form.addEventListener('wpcf7invalid', e => {

    let firstInvalidFieldId = e.detail.apiResponse.invalid_fields[0].error_id;
    setTimeout(function () {
      let firstInvalidField = e.target.querySelector(`input[aria-describedby=${firstInvalidFieldId}]`);
      firstInvalidField.focus();
    }, 100);

    disableSubmit = false;
  })
})
